import { setErrorStatus } from "../Redux/status/action";

export async function checkAccountAvailability(phoneNumber) {
  const response = await fetch(
    `${
      process.env.REACT_APP_BASE_URL
    }/profile/isExists?phoneNumber=${encodeURIComponent(phoneNumber)}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }
  );
  const result = await response.json();

  if (
    result.data?.moduleAccess?.support ||
    result.data?.moduleAccess?.independentEngineer
  ) {
    return true;
  }

  if (result.error) {
    if (result.error.name === "requestError") {
      setErrorStatus({ code: "custom", message: result.error.message });
    } else {
      throw result.error;
    }
  }

  return false;
}

export async function raiseComplaint(complaintData, accessToken) {
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/complaint`, {
    method: "POST",
    headers: {
      Accept: "*/*",
      "x-auth-token": `Bearer ${accessToken}`
    },
    body: complaintData
  });
  const result = await response.json();
  if (result.error) {
    throw result.error;
  }
  return result;
}
